((global) => {
  "use strict";

  const EVENT_NAMES = Object.freeze([
    "outfit_widget_view",
    "outfit_engagement",
    "outfit_launcher_click",
    "outfit_tab_select",
    "outfit_similar_open",
    "outfit_product_click",
    "outfit_add_to_cart_success",
    "outfit_add_to_cart_error",
  ]);
  const GA4_DESTINATION = /^G-[A-Z0-9]+$/;
  const stringValue = (value) => (value == null ? "" : String(value));
  function itemRole(context = {}) {
    const source = stringValue(context.sourceProductId);
    const target = stringValue(context.outfitProductId);
    if (!source || !target) return "";
    return source === target ? "source_item" : "recommended_item";
  }

  function eventParameters(eventName, context = {}, extra = {}) {
    if (!EVENT_NAMES.includes(eventName)) return {};
    const candidates = {
      source_product_id: context.sourceProductId,
      outfit_product_id: context.outfitProductId,
      outfit_id: context.outfitId,
      outfit_kind: context.outfitKind,
      outfit_surface: context.outfitSurface,
      outfit_item_role: itemRole(context),
      outfit_style: context.outfitStyle,
      outfit_variant_id: extra.outfit_variant_id,
      cart_attribute_status: extra.cart_attribute_status,
      error_stage: extra.error_stage,
    };
    return Object.entries(candidates).reduce((parameters, [key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        parameters[key] = stringValue(value);
      }
      return parameters;
    }, {});
  }

  function analyticsAllowed(scope) {
    try {
      const allowed = scope?.Shopify?.customerPrivacy?.analyticsProcessingAllowed;
      return typeof allowed === "function" && allowed.call(scope.Shopify.customerPrivacy) === true;
    } catch (_error) {
      return false;
    }
  }

  function deliverEvent(scope, destination, eventName, parameters = {}) {
    if (!EVENT_NAMES.includes(eventName)) return "invalid_event";
    if (!GA4_DESTINATION.test(stringValue(destination))) return "invalid_destination";
    if (!analyticsAllowed(scope)) return "consent_denied";

    const payload = { ...parameters, send_to: stringValue(destination) };
    if (typeof scope.gtag === "function") {
      scope.gtag("event", eventName, payload);
      return "sent";
    }
    if (Array.isArray(scope.dataLayer)) {
      (function queueGoogleTagCommand() {
        scope.dataLayer.push(arguments);
      })("event", eventName, payload);
      return "queued";
    }
    return "unavailable";
  }

  function track(destination, eventName, context, extra) {
    return deliverEvent(global, destination, eventName, eventParameters(eventName, context, extra));
  }

  const api = { EVENT_NAMES, analyticsAllowed, deliverEvent, eventParameters, itemRole, track };
  if (typeof module !== "undefined" && module.exports) module.exports = api;
  if (global) global.KixboxOutfitAnalytics = api;
})(typeof window !== "undefined" ? window : globalThis);
